import * as React from 'react';
import {
	StyledDownloadAllPopupContent, StartDownloadAllButton,
	KeepForLaterButton, DownloadAllPopupLabel, DownloadAllPopupClose,
	DontAskMeAgainContainer, DontAskMeAgainLabel
} from './styles';
import { Translate } from 'react-redux-i18n';
import Utils from '../../utils';

interface DownloadAllPopupContentProps {
	close: () => void;
	startDownloadAll: () => void;
	onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	isDontAskMeAgainChecked: boolean;
}

class DownloadAllPopupContent extends React.Component<DownloadAllPopupContentProps, {}> {

	render() {
		const { close, onCheckboxChange, startDownloadAll, isDontAskMeAgainChecked } = this.props;
		const checkboxName = 'dontAskMeAgainCheckbox';
		return (
			<StyledDownloadAllPopupContent className="DownloadAllPopupContent">
				<DownloadAllPopupClose className="DownloadAllPopupClose" onClick={close}>
					{Utils.getSvgIcon('iconset_close-1')}
				</DownloadAllPopupClose>
				<DownloadAllPopupLabel className="DownloadAllPopupLabel">
					<Translate value="messages.new_content_available_start_download"/>
				</DownloadAllPopupLabel>
				<StartDownloadAllButton className="DownloadAllPopupStartButton" onClick={startDownloadAll}>
					<Translate value="messages.start_to_download" />
				</StartDownloadAllButton>
				<KeepForLaterButton className="DownloadAllPopupKeepForLaterButton" onClick={close}>
					<Translate value="messages.keep_it_for_later" />
				</KeepForLaterButton>
				<DontAskMeAgainContainer className="DownloadAllPopupDontAskAgainContainer">
					<input
						type="checkbox"
						className="DownloadAllPopupDontAskAgainCheckbox"
						checked={isDontAskMeAgainChecked}
						onChange={onCheckboxChange}
						id={checkboxName}
					/>
					<DontAskMeAgainLabel className="DownloadAllPopupDontAskAgainLabel" htmlFor={checkboxName}>
						<Translate value="messages.dont_ask_me_again" />
					</DontAskMeAgainLabel>
				</DontAskMeAgainContainer>
			</StyledDownloadAllPopupContent>
		);
	}
}

export default DownloadAllPopupContent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DownloadAllPopupContent/index.tsx